import React, {  } from "react";
import {
  Dialog,
  List,
  ListItem,
  ListItemText,
  } from "@mui/material";
import CustomButton from "./CustomButton";
import { useTheme } from "@emotion/react";
import { tokens } from "../theme";

import {
  Grid,
  Stack,
  DialogContent,
  Typography,
  } from "@mui/material";
const PayoutErrorDetailsDialog = ({ open, onClose, files, previewFile, type }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleDownload = (refrenceId,attachmentType) => {
    previewFile(refrenceId, attachmentType);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent
        sx={{
          background: "white",
          borderRadius: "12px",
          overflow: "initial",
          marginBottom: "15px",
        }}
      >
        <Grid
          container
          direction={"column"}
          alignItems={"center"}
          alignContent={"center"}
          justifyItems={"center"}
          justifyContent={"center"}
        >
          <Grid container xs={10}>
            <Grid container justifyContent={"center"}>
              <Typography fontWeight={"600"} variant="h3" p={1}>
                Payout Error Detail
              </Typography>
            </Grid>

            {/* <DialogTitle>Available Attachment (Proff)</DialogTitle> */}
            <List>
              {files.map((file, index) => (
                <ListItem
                  button
                  //onClick={() => handleDownload(file.referenceId,file.attachmentType)}
                  key={index}
                >
                 {/* <ListItemIcon>
               {file.fileType === 'application/pdf' ? (
                 <PictureAsPdfIcon style={{ color: 'red' }} /> // Display PDF icon
               ) : (
                 <img
                   src={imageIcon}
                   alt="custom icon"
                   style={{ width: 24, height: 24 }} // Display image icon
                 />
               )}
             </ListItemIcon> */}

<ListItemText
sx={{ mb: 2 }}
  primary={
    <>
      <Typography variant="body2" color="textSecondary" fontWeight="bold" mr={2}>
        Account Code:
      </Typography>
      <Typography variant="body1">{file.accountCode}</Typography>
    </>
  }
/>

<ListItemText
sx={{ mb: 2 }}
  primary={
    <>
      <Typography variant="body2" color="textSecondary" fontWeight="bold" mr={2}>
        Post Amount:
      </Typography>
      <Typography variant="body1">{file.postAmount}</Typography>
    </>
  }
/>

<ListItemText
sx={{ mb: 2 }}
  primary={
    <>
      <Typography variant="body2" color="textSecondary" fontWeight="bold" mr={2}>
        Wht Amount:
      </Typography>
      <Typography variant="body1">{file.whtAmount}</Typography>
    </>
  }
/>

<ListItemText
sx={{ mb: 2 }}
  primary={
    <>
      <Typography variant="body2" color="textSecondary" fontWeight="bold" mr={2}>
        Re-attempt:
      </Typography>
      <Typography variant="body1">{file.reAttempt}</Typography>
    </>
  }
/>
       
              {/* <ListItemText primary={file.accountCode} />
              <ListItemText primary={file.postAmount} />
              <ListItemText primary={file.whtAmount} />
              <ListItemText primary={file.reAttempt} /> */}
                </ListItem>
              ))}
            </List>

            <Grid container justifyContent={"flex-end"}>
              <Stack
                direction="row"
                pt={2}
                spacing={2}
                justifyContent={"center"}
              >
                <CustomButton
                  btnBG={colors.primary[100]}
                  btnColor={colors.grey[900]}
                  btnTxt={"Cancel"}
                  btnBorder={"1px solid" + colors.primary[100]}
                  onClick={handleClose}
                ></CustomButton>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

// const FileDialogExample = () => {
//   const [open, setOpen] = useState(false);
//   const files = ['file1.txt', 'file2.pdf', 'file3.jpg']; // Sample files

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   return (
//     <div>
//       <Button variant="outlined" onClick={handleClickOpen}>
//         Open File Dialog
//       </Button>
//       <PayoutErrorDetailsDialog open={open} onClose={handleClose} files={files} />
//     </div>
//   );
// };

export default PayoutErrorDetailsDialog;
